import { Outlet } from "react-router";
import Header from "../../../../../component/layout/header";
import useNav from "../../../../../script/tabingNavArray";

const LostDealLayout = () => {
  const navList = useNav();
  let { lostDealsBottomHeader, OperationsTopHeader } = navList;
  return (
    <div className="webBody">
      <Header
        bottomTabs={lostDealsBottomHeader}
        topTabs={OperationsTopHeader}
      />
      <Outlet />
    </div>
  );
};

export default LostDealLayout;
